import { Skeleton as MuiSkeleton } from '@mui/material';
import type { SkeletonProps } from '@mui/material';

export const Skeleton = (props: SkeletonProps) => {
  return <MuiSkeleton {...props} />;
};

// Componentes específicos para diferentes tipos de conteúdo
export const TextSkeleton = ({ width = '100%', height = 20 }: { width?: string | number, height?: number }) => (
  <Skeleton variant="text" width={width} height={height} />
);

export const AvatarSkeleton = ({ size = 40 }: { size?: number }) => (
  <Skeleton variant="circular" width={size} height={size} />
);

export const ImageSkeleton = ({ width = '100%', height = 200 }: { width?: string | number, height?: number }) => (
  <Skeleton variant="rectangular" width={width} height={height} />
);

export const CardSkeleton = ({ width = '100%', height = 200 }: { width?: string | number, height?: number }) => (
  <Skeleton variant="rounded" width={width} height={height} />
); 